// import BalanceService from '@/services/balance'

export default {
	setTransaction({commit}, payload) {
		commit('SET_TRANSACTION_PRODUCT', payload)
		return Promise.resolve(payload)
	},
	setTransactionPayment({commit, payload}) {
		commit('SET_TRANSACTION_PAYMENT', payload)

		return Promise.resolve(payload)
	}
}